export const ONE_GROVE_MENU_ID = 'ONE_GROVE_PARKING';

export const ONE_GROVE_PARKING_MENU = {
  id: ONE_GROVE_MENU_ID,
  type: 'parking',
  name: {
    ko: '주차안내',
    en: 'Parking',
    ja: 'Parking',
    cn: 'Parking',
    tw: 'Parking',
  },
  iconUsed: true,
  mainIconUri: 'https://resource.platform.dabeeo.co.kr/coldbox/public/menu-icons/3B84-20250513-101456-740.svg',
  subIconUri: 'https://resource.platform.dabeeo.co.kr/coldbox/public/menu-icons/3B84-20250513-101456-740.svg',
  customPageId: null,
};

export const ONE_GROVE_MAP_ID = process.env.REACT_APP_ONE_GROVE_MAP_ID;
